<p-card class="mb-4">
    <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12 sm:col-span-6 md:col-span-4 2xl:col-span-3">
            <p-select class="multiselect-stocks" [options]="types" [(ngModel)]="filters.type" [filter]="false" fluid placeholder="Type d'écart" optionLabel="name" optionValue="value" fluid  (onChange)="onSelectChange($event)"></p-select>
        </div>

        <div class="col-span-12 sm:col-span-6 md:col-span-4 2xl:col-span-3">
            <p-inputnumber [(ngModel)]="filters.prix_min" (onInput)="onInput()" mode="currency" currency="EUR" locale="fr-FR" autocomplete="off" fluid placeholder="Prix minimum"/>
        </div>

        <div class="col-span-12 sm:col-span-6 md:col-span-4 2xl:col-span-3">
            <p-button label="Réinitialiser" icon="pi pi-undo" iconPos="right" (click)="onClear()" text />
        </div>
    </div>
</p-card>

<p-card>
    <p-table
        #dt
        [value]="sortedStockListEbays"
        dataKey="stock_id"
        [lazy]="true"
        [paginator]="true"
        [totalRecords]="resultsLength"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="{first} - {last} sur {totalRecords}"
        [rows]="pageSize"
        [rowsPerPageOptions]="[10, 20, 50]"
        [columns]="selectedColumns"
        [loading]="isLoadingResults"
        [scrollable]="true"
        scrollHeight="634px"
        (onLazyLoad)="onLazyLoad($event)"
        (onStateRestore)="onStateRestore($event)"
        stateKey="_sle"
        stateStorage="local"
        rowGroupMode="rowspan"
        groupRowsBy="produit_id"
    >
        <ng-template #header let-columns>
            <tr>
                <th class="w-12"></th>
                @for (col of columns; track $index) {
                    @if (col.field == 'produit_id') {
                        <th class="w-32">{{ col.header }}</th>
                    }
                    @else {
                        <th>{{ col.header }}</th>
                    }
                }
                <th class="w-12"></th>
            </tr>
        </ng-template>

        <ng-template #body let-sortedStock let-columns="columns" let-rowgroup="rowgroup" let-rowspan="rowspan">
            <tr>
                <td *ngIf="rowgroup" [attr.rowspan]="rowspan" class="w-12">
                    <p-button icon="pi pi-shopping-bag" [rounded]="true" text [routerLink]="['/products', sortedStock.produit_id]" [queryParams]="{tab: 7}" pTooltip="Diffusions" tooltipPosition="top"/>
                </td>
                @for (col of columns; track $index) {
                    @switch (col.field) {
                        @case ('produit_id') {
                            <td *ngIf="rowgroup" [attr.rowspan]="rowspan" class="w-32">
                                <a [routerLink]="['/products', sortedStock.produit_id]" class="flex flex-col justify-center items-center">
                                    <img [src]="apiUrl + sortedStock.photo_couverture" alt="{{sortedStock.reference}}" width="80" height="80" class="h-20 w-20 shadow-lg object-cover rounded-md" />
                                    <p-tag severity="contrast" [value]="'#' + sortedStock.produit_id" class="-mt-3 relative z-0 !text-base" />
                                </a>
                            </td>
                        }
                        @case ('produit_marque') {
                            <td *ngIf="rowgroup" [attr.rowspan]="rowspan">{{ sortedStock[col.field] }}</td>
                        }
                        @case ('produit_reference') {
                            <td *ngIf="rowgroup" [attr.rowspan]="rowspan">{{ sortedStock[col.field] }}</td>
                        }
                        @case ('stock_etat') {
                            <td><p-tag [severity]="utilityService.getStateSeverity(sortedStock.stock_etat)" [value]="utilityService.getStateLabel(sortedStock.stock_etat)" class="mt-2" /></td>
                        }
                        @case ('stock_prix') {
                            <td>{{ sortedStock[col.field] | currency:'EUR' }}</td>
                        }
                        @case ('stock_quantite') {
                            <td>{{ sortedStock[col.field] }}</td>
                        }
                        @default {
                            <td>{{ sortedStock[col.field] }}</td>
                        }
                    }
                }
                <td class="w-12">
                    <p-button icon="pi pi-chevron-right" [rounded]="true" text [routerLink]="['/products', sortedStock.produit_id]" [queryParams]="{stock_id: sortedStock.stock_id}" pTooltip="Détail stock" tooltipPosition="top"/>
                </td>
            </tr>
        </ng-template>
    </p-table>
</p-card>
